module.exports = __webpack_public_path__ + "assets/img/955828cca545d4a36f4bbb65682ac670.png";